// Web shim for the `react-native` package.
//
// `react-native-web` is the canonical browser implementation of RN's
// component + StyleSheet APIs, but it deliberately omits a handful of
// RN-internal modules that the JS bundle would normally use to talk to
// the native bridge (TurboModuleRegistry, NativeModules, etc). Some
// downstream RN-only libraries — most notably `react-native-svg` (and
// transitively `lucide-react-native`) — `import { TurboModuleRegistry
// } from 'react-native'` at module load and crash with
// "does not provide an export named 'TurboModuleRegistry'" the first
// time their bundle hits the browser.
//
// This shim re-exports everything from `react-native-web` AND adds
// no-op fallbacks for the missing native-bridge APIs. The libraries
// that probe these typically branch on whether the registry returns
// a non-null module — returning `null` lets them fall back to their
// JS implementation (which IS the web path).
//
// Wired in `vite.config.ts` under `resolve.alias` for `^react-native$`.

export * from 'react-native-web';

// `TurboModuleRegistry` (and the legacy `NativeModules`) are the
// new/old native-bridge registrars. On web both are no-ops.
export const TurboModuleRegistry = {
  get: () => null,
  getEnforcing: (_name) => {
    // `getEnforcing` is supposed to throw if the native module is
    // missing. Returning a stub object that responds to common probe
    // calls keeps libraries that DON'T tolerate missing TurboModules
    // from crashing at import time. If they actually try to call
    // through, they'll noop and the library has to handle that.
    return new Proxy(
      {},
      {
        get: () => () => undefined,
      },
    );
  },
};

export const NativeModules = new Proxy(
  {},
  {
    get: () => undefined,
  },
);

// `codegenNativeCommands` — RN 0.74+ codegen helper that some libs
// import. On web it has nothing to wire to; return a no-op factory.
export const codegenNativeCommands = () => ({});

// `UIManager` exists on `react-native-web` already but some deep
// imports look for a specific shape. Re-export is enough.
